import { render, staticRenderFns } from "./invalid-address.vue?vue&type=template&id=32954b57&scoped=true"
import script from "./invalid-address.vue?vue&type=script&lang=js"
export * from "./invalid-address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32954b57",
  null
  
)

export default component.exports